import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./wrapper.js";

/**
 * Mount once inside `<BrowserRouter>` to fire a page-view event on every
 * route change (and on the initial render). Per `cross-cutting/analytics.mdc`,
 * apps NEVER call `trackPageView()` manually — this component is the one
 * place page-views originate.
 */
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
